<template>
    <div class="forget-password-component">
        <div class="global_popup_header">{{$t('login.find')}}</div>
        <div class="global_popup_body">
            <el-form label-position="top" label-width="80px" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent>
                <el-form-item :label="$t('login.email')" prop="email">
                    <el-input v-model="ruleForm.email" :placeholder="$t('login.email')" @keyup.enter.native="submitForm('ruleForm')"></el-input>
                </el-form-item>
                <span @click="backHandle" class="btn-wrap">{{$t('commonMsg.back')}}</span>                  
            </el-form>
        </div>
        <div class="global_popup_footer">
            <button @click="submitForm('ruleForm')">{{$t('login.send')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name:'ForgetPassword',
    computed: {
        rules() {
            const rules = {
                email: [{required: true, message: this.$t('verify.email'), trigger: 'blur'}]
            }
            return rules
        },
    },
    data() {
        return {
            ruleForm: {
                email:''
            },
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendHandle()
                } else {
                    return false;
                }
            })
        },

        sendHandle(){
            this.$http.forgetPass(this.ruleForm)
            .then(res => {
                this.$message({type: 'success', message: this.$t('login.tip')})
            })
            .catch(() => {})
        },

        backHandle() {
            this.$emit('changeComponent')
        }
    }
}
</script>

<style lang="scss" scoped>
    .forget-password-component{
        @include globalPopup(460px, 290px);
        .global_popup_body{
            .btn-wrap{
                cursor: pointer;
            }
        }
    }
</style>